export const editableMergeField = {
    CaseType: 1,
    EmployeeType: 2,
    OfficeAddressType: 3,
    EventType: 4,
} as const
